import { DeskPresentation } from './commodity-reports.model';

/**
 * Absolute base of the hosted commodity-report bundle on the Reporting Service
 * (confirmed with backend, YUK-293). Every report URL the manifest returns is
 * relative to this base, e.g. "/2026-07-12/index.html".
 */
export const COMMODITY_REPORTS_BASE =
  'https://reporting-service.api.yukkalab.com/content/commodities_ad7geesh';

/**
 * Stable "latest" manifest — the single entry point for the page. Points to the
 * current dated snapshot. (Endpoint may not be live in every environment yet.)
 */
export const COMMODITY_REPORTS_MANIFEST_URL = `${COMMODITY_REPORTS_BASE}/manifest.json`;

/**
 * Icons/subtitles are presentation-only and not part of the manifest, so they
 * live here keyed by desk id. Unknown desks fall back to DEFAULT_DESK_PRESENTATION.
 */
export const DESK_PRESENTATION: Record<string, DeskPresentation> = {
  energy_desk: {
    icon: 'bolt',
    subtitle: 'Crude, refined products, gas & power',
  },
  metals_desk: {
    icon: 'layers',
    subtitle: 'Base & precious metals, bulks and ferroalloys',
  },
  soft_desk: {
    icon: 'grass',
    subtitle: 'Grains, oilseeds, tropicals and fibres',
  },
};

export const DEFAULT_DESK_PRESENTATION: DeskPresentation = {
  icon: 'description',
  subtitle: '',
};
